var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNoItemsAvailable = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 118,
  height: 120,
  fill: "none",
  ref: ref
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 58.968,
  cy: 58.968,
  r: 58.968,
  fill: "#F0F8FF"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#799DEC",
  d: "M17.778 37.275h79.899a3.866 3.866 0 0 1 3.861 3.862l-4 69.637a3.864 3.864 0 0 1-3.861 3.862H21.778a3.86 3.86 0 0 1-3.862-3.862l-4-69.637a3.864 3.864 0 0 1 3.862-3.862"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m26.63 89.648 61.992.296c2.006.01 3.64-1.779 3.651-3.994l.306-63.917c.01-2.215-1.607-4.02-3.613-4.029l-61.992-.296c-2.006-.01-3.641 1.778-3.652 3.994l-.305 63.917c-.011 2.215 1.607 4.02 3.613 4.029"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#E9EFFC",
  d: "M34.6 26.898c0-.524.562-.95 1.255-.95l28.855.006c.693 0 1.254.425 1.254.95v1.9c0 .524-.562.949-1.255.949l-28.855-.005c-.693 0-1.255-.426-1.254-.95zm-5.704 9.7c0-.524.541-.95 1.209-.95l35.034.006c.667 0 1.208.426 1.208.95v1.9c0 .524-.542.95-1.209.95l-35.034-.007c-.667 0-1.208-.425-1.208-.95z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#1186FA",
  d: "M73.203 37.993c-.371-.371-.49-.853-.267-1.077L84.68 25.172c.224-.223.706-.104 1.077.267l1.343 1.343c.37.37.49.853.266 1.076L75.622 39.602c-.223.224-.705.105-1.076-.266z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#1186FA",
  d: "M87.1 37.993c.37-.371.49-.853.266-1.077L75.622 25.172c-.224-.223-.706-.104-1.077.267l-1.343 1.343c-.37.37-.49.853-.266 1.076L84.68 39.602c.223.224.705.105 1.076-.266z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#E9EFFC",
  d: "M28.894 46.298c0-.524.413-.95.922-.95l57.125.01c.51 0 .922.426.922.95v1.9c0 .524-.413.95-.922.95l-57.126-.01c-.509 0-.921-.426-.921-.95zm3.808-18.452a1.9 1.9 0 1 1-3.799 0 1.9 1.9 0 0 1 3.8 0Z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#a)",
  d: "M76.649 57.484 64.163 69.97H76.65V57.484Z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#BCCEF5",
  d: "m10.063 73.6 5.384 43.079A3.86 3.86 0 0 0 19.27 120h76.913a3.86 3.86 0 0 0 3.824-3.321l7.275-56.466a3.862 3.862 0 0 0-3.824-4.401H35.381a3.86 3.86 0 0 0-3.824 3.32l-.953 6.744a3.86 3.86 0 0 1-3.824 3.321H13.886a3.86 3.86 0 0 0-3.823 4.402Z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#799DEC",
  d: "M29.138 98.032h57.178a1.29 1.29 0 0 0 1.277-1.126l.715-5.664a1.286 1.286 0 0 0-1.277-1.448H28.423a1.29 1.29 0 0 0-1.277 1.448l.715 5.664a1.29 1.29 0 0 0 1.277 1.126"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: 68.4,
  x2: 83.492,
  y1: 71.974,
  y2: 56.882,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C2CECE",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.179,
  stopColor: "#AFBCBC",
  stopOpacity: 0.179
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5B6A6A"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgNoItemsAvailable);
export default ForwardRef;